export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_01_47_08.Still008.54fb2f96.jpg";